export class PopupEvents {
    static get select(): string { return "productionplanning_popup_select"; }
    static get addAtgardToArbetsorder(): string { return "productionplanning_map_addAtgardToArbetsorder"; }
}
